export function readStoredUser() {
  if (typeof window === "undefined") return null;

  try {
    const rawUser = localStorage.getItem("user");
    if (!rawUser) return null;

    const parsedUser = JSON.parse(rawUser);
    return parsedUser && typeof parsedUser === "object" ? parsedUser : null;
  } catch (error) {
    console.error("Failed to read stored user:", error);
    return null;
  }
}

export function writeStoredUser(user) {
  if (typeof window === "undefined") return null;

  try {
    if (user && typeof user === "object") {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }

    window.dispatchEvent(
      new CustomEvent("rpo:user-updated", {
        detail: user && typeof user === "object" ? user : null,
      })
    );

    return user && typeof user === "object" ? user : null;
  } catch (error) {
    console.error("Failed to write stored user:", error);
    return null;
  }
}

export function mergeStoredUser(patch = {}) {
  const currentUser = readStoredUser() || {};
  return writeStoredUser({ ...currentUser, ...patch });
}
